import 'view-base/unit-link'

// ----------------------------------------
// Create standard link which is handled
// in action of view-advice
// ----------------------------------------
export function replaceLink( text = "", value, label ) {
  // Build link
  const link = `<unit-link class="router" value="${value}" label="${label}"></unit-link>`
  // Ignore Cases
  const regs = new RegExp( label, "gi" )
  // Return unsafeHTML for further processing
  return text.replace( label, link )
}